export const VIRTUAL_DEPART_DRIVER = "VIRTUAL_DEPART_DRIVER";
export const VIRTUAL_DEPART_STORE = "VIRTUAL_DEPART_STORE";
export const VIRTUAL_DEPART_DRIVER_SUCCESS = "VIRTUAL_DEPART_DRIVER_SUCCESS";
export const VIRTUAL_DEPART_DRIVER_ERROR = "VIRTUAL_DEPART_DRIVER_ERROR";
export const VIRTUAL_DEPART_STORE_SUCCESS = "VIRTUAL_DEPART_STORE_SUCCESS";
export const VIRTUAL_DEPART_STORE_ERROR = "VIRTUAL_DEPART_STORE_ERROR";
export const VIRTUAL_DEPART_DRIVER_RESET = "VIRTUAL_DEPART_DRIVER_RESET";
export const VIRTUAL_DEPART_DRIVER_ERROR_MSG = "Error in departing driver";

export const RESPONSE_TYPE = {
    SUCCESS:"success",
    ERROR: "error",
    WARN: "warning"
}




// WEBPACK FOOTER //
// ./src/components/virtualDepartDriver/constants/VirtualDepartDriverConstants.js